import styled from 'styled-components';
import { media } from '../../../Utils/mediaQueries';

const borderColor = 'rgba( 70, 70, 70, 0.5)';

export const AvatarWrapper = styled.div`
    ${({ size }) => {
        switch (size) {
            case 'small': {
                return `
					width: 30px;
					height: 30px;
					border: 2px solid ${borderColor};
				`;
            }

            case 'large': {
                return `
					width: 128px;
					height: 128px;
					border: 6px solid ${borderColor};
				`;
            }

            case 'medium': {
                return `
					width: 42px;
					height: 42px;
					border: 2px solid ${borderColor};
				`;
            }

            case '_base': {
                return `
					width: 92px;
					height: 92px;
					border: 2px solid ${borderColor};
				`;
            }

            default: {
                return null;
            }
        }
    }};

    border-radius: 50%;
    overflow: hidden;
    flex: none;

    & > img {
        width: 100%;
        height: 100%;
        border-radius: 50%;
        object-fit: cover;
    }

    ${media.phone`
        ${({ size }) => {
            switch (size) {
                case 'large': {
                    return `
                        width: 74px;
                        height: 74px;
                    `;
                }
                default: {
                    return null;
                }
            }
        }};
    `};
`;



// WEBPACK FOOTER //
// ./src/UI/Components/ProfileAvatar/style.js